import { Box, type SxProps, type Theme } from '@mui/material';

type ImageOverlayProps = {
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
};

export const ImageOverlay = ({ children, sx }: ImageOverlayProps) => (
  <Box
    sx={{
      position: 'absolute',
      ...sx,
    }}
  >
    {children}
  </Box>
);
